export const QA_NAME_VIEWING_PROFILE_WIDGET_APPLICANTS =
  'viewingProfileApplicants'

export const QA_NAME_VIEWING_APPLICANTS_ADD_BTN = 'viewingApplicantsAddBtn'

export const QA_NAME_VIEWING_APPLICANTS_DELETE_BTN =
  'viewingApplicantsDeleteBtn'

export const VIEWING_APPLICANTS_FIELD_NAME = 'applicants'
